import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { globalImportUrl } from '../core/request';
/**
 * Get Achievement Template
 * Get achievement template mapping, including name, image, and description
 * @param templateId ID for the achievement template
 * @param imageType achievement badge image type
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @returns AchievementTemplate Successful response
 * @throws ApiError
 */

export var getAchievementTemplate = function getAchievementTemplate(api, templateId, imageType, acceptLanguage) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/achievement_template/".concat(templateId);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof imageType !== 'undefined') {
    localVarQueryParameter['image_type'] = imageType;
  }

  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get User Achievements
 * Get number of times user has earned each type of achievements, grouped by category. Shows some unearned achievements within the category, with different logic depending on the category. The order of the categories and the achievements within each category is specified in CMS. This endpoint will return an error is accessed for a private user by someone who does not follow them.
 * @param userId ID for the user
 * @param imageType achievement badge image type
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @returns any Successful response
 * @throws ApiError
 */

export var getUserAchievements = function getUserAchievements(api, userId, imageType, acceptLanguage) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/".concat(userId, "/achievements");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof imageType !== 'undefined') {
    localVarQueryParameter['image_type'] = imageType;
  }

  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets workout's achievement list
 * Returns workout's achievement list.
 * @param workoutId
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @returns any Successful response
 * @throws ApiError
 */

export var getWorkoutAchievements = function getWorkoutAchievements(api, workoutId, acceptLanguage) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/workout/".concat(workoutId, "/achievements");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};